<template>
  <footer class="footer">
    <div class="container">
      <ul>
        <li>
          <span
            >{{$t('contentFooter.poweredByExtremeDigitalSolutions')}} &copy;
            {{ new Date().getFullYear()  }}</span
          >
        </li>
      </ul>
    </div>
  </footer>
</template>
<script>
export default {}
</script>
<style></style>
